import { render, staticRenderFns } from "./CartHeader.vue?vue&type=template&id=50c09138"
import script from "./CartHeader.ts?vue&type=script&lang=ts&external"
export * from "./CartHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./CartHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports